const data = [
  { title: 'Outsourcing', items: [
    'Accounting for High Net worth Individuals', 'Corporate Secretarial',
    'Maintenance of entire accounts for Private Equity/Multinational Companies',
    'Maintenance of companies – domestic or foreign – by providing registered \
    office space,directors,maintaining accounts and taxes,compliance with all \
    statutory formalities',
  ]},
  { title: 'Audits', items: [
    'Statutory, Internal & System Audits',
    'Stock & Book Debts Audit for Banks Management',
    'Audits under Transfer Pricing Regulations',
    'Audits under various Indirect Tax Laws',
    'Investigations & Special Audits as required by the management',
    'Audits of Depository Participants & Stock Brokers',
    'Audits of Non Government Organizations'
  ]},
  { title: 'Direct Taxes Planning & Compliance', items: [
    'Direct taxes planning & advisory', 'Filing of Returns & tax audits',
    'Representations & litigation support including assessments and appeals',
    'Tax compliance review & due diligence', 'Transaction Structuring',
    'DTAA advice on cross border investment and transactions structuring',
    'Domestic & International Transfer Pricing'
  ]},
  { title: 'Company Law & Related Matters', items: [
    'Formation of Companies, Limited Liability Partnerships, Joint Ventures, \
     Branch Offices, Liaison Offices in India',
     'Setting up of trusts, societies, section 25 companies under the provisions \
      of the Companies Act, 2013',
    'Conversion of companies into limited liability partnerships and partnerships Advisory Services',
    'Assistance & advice for compliance with Corporate Social Responsibility (CSR)',
    'Preparation of Statutory Records & Registers',
  ]},
  { title: 'Transaction Advisory', items: [
    'Joint Ventures, Foreign Collaborations, Franchise Agreements',
    'Information Memorandums, Business Plans, Project Reports',
    'Due diligence reviews',
    'Mergers & Acquisitions',
  ]},
  { title: 'Indirect Taxes Advisory & Compliance', items: [
    'Indirect taxes planning, advisory, registrations, filing of Returns & tax audits',
    'Representations & litigation support including assessments and appeals',
    'Tax compliance review & due diligence',
    'Advisory on GST implementation & compliance',
  ]},
  { title: 'Legal Assistance', items: [
    'Verbal & written opinions to deal with current and future litigations related to \
     direct and indirect taxes',
    'Strong network of experts in various tax laws',
    'Leverage our understanding of the clients’problem with our network of experts',
    'Vetting of legal documents & agreements',
  ]},
  { title: 'Overseas Direct Investment & Foreign Direct Investment', items: [
    'Transaction structuring & advice for outbound & inbound investment',
    'Advisory for setting up wholly owned subsidiary or joint venture outside India',
    'FEMA/ODI/FDI compliant valuations',
    'Preparation of application, documents and obtaining approvals from authorities \
     (RBI, FIPB, Industrial Licenses etc.)',
     'Ongoing compliance services',
     'International taxation (especially for USA) preparation & filing of Tax, FBAR'
  ]},
];
export default data;



// WEBPACK FOOTER //
// ./src/ServicesPage/data.js